/**
 * Find duplicate properties or computed strings in an object list.
 * @returns A set of the properties or computed strings with repeats
 */
export function findDuplicates<T>(objects: T[], accessor: (obj: T) => string) {
  const seenOnce = new Set<string>();
  const seenMultiple = new Set<string>();
  objects.forEach((o) => {
    if (!seenOnce.has(accessor(o))) {
      seenOnce.add(accessor(o));
    } else {
      seenMultiple.add(accessor(o));
    }
  });
  return seenMultiple;
}
